import * as CheckoutActionTypes from 'Types/CheckoutActionTypes';
import { flattenShipmentProducts } from 'Utilities/ArrayUtilities';

// Constructor.io purchase tracking for the order confirmation page.
// Spec: "Speedway Motors - Tracking & Integration Review" (Order Confirmation Page section).
// Revenue matches the other analytics middlewares (Segment/GA/Facebook): orderSubTotal.

const toNumber = (price) => {
    if (typeof price === 'number') {
        return price;
    }
    const parsed = parseFloat(String(price).replace(/[^0-9.-]/g, ''));
    return isNaN(parsed) ? 0 : parsed;
};

const ConstructorMiddlewareAction = (action) => {
    if (action.type !== CheckoutActionTypes.HYDRATED_CONFIRMATION_STEP) {
        return;
    }

    try {
        const transaction = action.payload.checkoutTransactionRm;
        const confirmation = transaction && transaction.confirmation;
        if (!confirmation) {
            return;
        }

        const items = flattenShipmentProducts(transaction).map((p) => ({
            item_id: p.skuBase,
            count: p.quantity,
            price: toNumber(p.price),
            // Only surface a variation id when it differs from the base sku.
            ...(p.skuVariant && String(p.skuVariant) !== String(p.skuBase) && { variation_id: p.skuVariant }),
        }));

        window.cnstrc = window.cnstrc || {};
        window.cnstrc.purchaseData = {
            revenue: toNumber(confirmation.orderAndBackorderTotal),
            orderId: confirmation.isSplitOrder ? confirmation.masterOrderNumber : confirmation.orderNumbers[0],
            items,
        };
    } catch (e) {
        console.error(e);
    }
};

export default ConstructorMiddlewareAction;
